import React from "react";
import "./card.css";
import { UserPlus, Verified, CreditCard } from "lucide-react";
const features = [
  {
    name: "Sign Up",
    description: "Sign up for onboarding on QFS, then verify your identity.",
    icon: UserPlus,
  },
  {
    name: "Wait For Approval",
    description:
      "Once KYC Submission is Approved, proceed to Sync your wallet with KYC. You can also Apply for Humanitarian Project.",
    icon: Verified,
  },

  {
    name: "Get QFS Card",
    description:
      "Get your QFS Cards now to get acquainted with the Quantum Med beds, Quantum Computers, Q-phones and Shop in over 118 countries.",
    icon: CreditCard,
  },
];
const Card = () => {
  return (
    <div className="about-section" id="about">
      <div className="about-wrapper">
        <div className="why-choose-us-text-container about-text">
          <h1 data-aos="fade-up">
            Get access to QFS CARDS that allows you to shop in over 118
            countries worldwide
          </h1>
          <p data-aos="fade-up">
            Sign up to synchronize your digital Wallets with QFS now for maximum
            cyber security and swift funding/transfer of your assets using the
            Quantum Finance Credit Card
          </p>
          <dl className="mt-10 max-w-xl space-y-8 text-base/7 text-gray-600 lg:max-w-none">
            {features.map((feature) => (
              <div
                key={feature.name}
                data-aos="fade-up"
                className="relative pl-9"
              >
                <dt className="inline font-semibold text-gray-900">
                  <div >
                    <feature.icon
                    height={24}
                    width={24}
                      aria-hidden="true"
                      className="absolute top-1 left-1 size-5 text-indigo-600"
                    />
                  
                  </div>

                  {feature.name}
                </dt>{" "}
                <dd>{feature.description}</dd>
              </div>
            ))}
          </dl>
          <a
            className="launch-btn launch"
            data-aos="fade-up"
            href="https://www.qfs1776.com/_files/ugd/a16bfe_46e53371c3924d10a587d58fb9e5a0e1.pdf"
          >
            <svg
              height="24"
              width="24"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M0 0h24v24H0z" fill="none"></path>
              <path
                d="M5 13c0-5.088 2.903-9.436 7-11.182C16.097 3.564 19 7.912 19 13c0 .823-.076 1.626-.22 2.403l1.94 1.832a.5.5 0 0 1 .095.603l-2.495 4.575a.5.5 0 0 1-.793.114l-2.234-2.234a1 1 0 0 0-.707-.293H9.414a1 1 0 0 0-.707.293l-2.234 2.234a.5.5 0 0 1-.793-.114l-2.495-4.575a.5.5 0 0 1 .095-.603l1.94-1.832C5.077 14.626 5 13.823 5 13zm1.476 6.696l.817-.817A3 3 0 0 1 9.414 18h5.172a3 3 0 0 1 2.121.879l.817.817.982-1.8-1.1-1.04a2 2 0 0 1-.593-1.82c.124-.664.187-1.345.187-2.036 0-3.87-1.995-7.3-5-8.96C8.995 5.7 7 9.13 7 13c0 .691.063 1.372.187 2.037a2 2 0 0 1-.593 1.82l-1.1 1.039.982 1.8zM12 13a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
                fill="currentColor"
              ></path>
            </svg>
            <span> Get Started</span>
          </a>
        </div>
        <div className="about-img-container">
          <img
            width={2432}
            height={1442}
            data-aos="fade-up"
            src="./card.png"
            alt="card"
            className="about-img"
          />
        </div>
      </div>
    </div>
  );
};

export default Card;
